import PubSub from 'PubSub'

export default new PubSub()
